import { clsx } from 'clsx';
import { FC, PropsWithChildren, useState } from 'react';
import { IReactMultiEmailProps, ReactMultiEmail } from 'react-multi-email';
import { IconButton } from '../button/icon-button.tsx';
import { XmarkIcon } from '../icons/react';
import {
  emailTag,
  multiEmail,
  multiEmailError,
  multiEmailIsFocused,
  multiEmailLabel,
  multiEmailWithError,
} from './multi-email.css.ts';

export const MultiEmail: FC<
  IReactMultiEmailProps & { label?: string; errorMessage?: string }
> = ({ onFocus, onBlur, label, errorMessage, ...props }) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div>
      {label && <label className={multiEmailLabel}>{label}</label>}
      <ReactMultiEmail
        onFocus={() => {
          setIsFocused(true);
          onFocus?.();
        }}
        onBlur={() => {
          setIsFocused(false);
          onBlur?.();
        }}
        className={clsx(
          multiEmail,
          isFocused && multiEmailIsFocused,
          errorMessage && multiEmailWithError,
        )}
        data-focused={isFocused ? '' : undefined}
        {...props}
      />
      {errorMessage && <p className={multiEmailError}>{errorMessage}</p>}
    </div>
  );
};

export const MultiEmailTag: FC<
  PropsWithChildren<{
    removeEmail: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  }>
> = ({ removeEmail, children }) => (
  <div className={emailTag}>
    {children}
    <IconButton size={'xSmall'} variant={'ghost'} onClick={removeEmail}>
      <XmarkIcon />
    </IconButton>
  </div>
);
